.root {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 14px;
  border-radius: var(--radius-lg);
  background: var(--color-surface);
  border: 1px solid var(--color-border);
}

.heading {
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-text-tertiary);
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 9px;
}

.item {
  display: flex;
  align-items: center;
  gap: 9px;
}

.icon {
  font-size: 16px;
  color: var(--color-brand-secondary);
  flex-shrink: 0;
}

.copy {
  display: flex;
  flex-direction: column;
  line-height: 1.25;
  min-width: 0;
}

.label {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--color-text);
}

.detail {
  font-size: 11px;
  color: var(--color-text-tertiary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
